import { render, staticRenderFns } from "./yearOutputTotal.vue?vue&type=template&id=66f4f40c&scoped=true&"
import script from "./yearOutputTotal.vue?vue&type=script&lang=js&"
export * from "./yearOutputTotal.vue?vue&type=script&lang=js&"
import style0 from "./yearOutputTotal.vue?vue&type=style&index=0&id=66f4f40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f4f40c",
  null
  
)

export default component.exports